import { useDroppable } from "@dnd-kit/core";
import { C_fondolistaspar, C_transparente } from "../constantes/generales";

const Droppable = ({children, id, fondo=C_fondolistaspar}) => {
    const {isOver, setNodeRef} = useDroppable({id: id});

    const style =  {
          background: fondo,
          borderRadius: "4px",
      }

      const style2 =  {
          background: C_transparente,
      }

      //className={`${isOver ? 'CT_droppableOver' : 'CT_droppable'} `}
  
  
      return(
          <div ref={setNodeRef} style={isOver ? style : style2} >
              {children}
          </div>
      );
  
};

export default Droppable;